import { Subscription } from 'rxjs/Subscription';
import { DataTransferService } from 'src/app/shared/services/common/datatransfer.service';
import { Component, EventEmitter, OnInit, TemplateRef, ViewChild, Inject, OnDestroy } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { DOCUMENT } from '@angular/common';
import { FacebookPixelService } from 'src/app/facebook-pixel/facebook-pixel.service';
import { ChangeDetectorRef } from '@angular/core';
import { RazorpayPgService } from '@pv-frontend/razorpay-pg';

interface offer {
  id: string,
  merchantLogoUrl: string,
  offerType: string,
  endDate: string,
  merchantName: string,
  redemptionUrl: string,
  offerTitle: string,
  pva: string
}

@Component({
  selector: 'app-coupon-modal',
  templateUrl: './coupon-modal.component.html',
  styleUrls: ['./coupon-modal.component.scss'],
  providers: [ApiService]
})
export class CouponModalComponent implements OnInit,  OnDestroy {
  redeemResponseEvent: EventEmitter<any> = new EventEmitter();
  paymentLoad = false;
  selectedOffer: offer;
  copiedCode: boolean = false;
  couponLoading: boolean;

  redeemActive: boolean = false;
  redeeming = false;
  voucherData:any = {};
  currentCard:any;
  cardsSubscription: Subscription;
  emitRedeem = new EventEmitter<boolean>();
  paymentClicked: boolean = false;

  constructor(public GlobalConstants: GlobalConstants,
    private _apiService: ApiService,
    private toastr: ToastrService,
    public _bsModalRef: BsModalRef,
    private dataTransferService: DataTransferService,
    @Inject(DOCUMENT) private document: any,
    private fpService: FacebookPixelService,
    private changeDetector: ChangeDetectorRef,
    private pgService: RazorpayPgService
  ) { 
    this.pgService.paymentModalClosedEvent.subscribe((isClosed: any) => {
      this.paymentClicked = !isClosed;
      this.changeDetector.detectChanges();
    })
  }

  ngOnInit(): void {
    this.proceedToRedeem();
  }

  proceedToRedeem() {
    this.couponLoading = true;
    let params = {}
    if (localStorage.getItem('cardSelected')) {
      params = JSON.parse(localStorage.getItem('cardSelected'));
    }

    this._apiService.redeem({ id: this.selectedOffer.id }, params).subscribe(
      (res: any) => {
        this.couponLoading = false;
        this.voucherData = res;
        if(this.voucherData.voucher_code != null && this.voucherData.voucher_code.length > 0 && this.voucherData.voucher_code.includes("https://")){
          this.voucherData['offer_type'] = 'link_voucher';
        }
        this.redeemResponseEvent.emit({
          response: 'success'
        })
      },
      (err) => {

        this.couponLoading = false;
        if(err.status && err.status === 402){
          const currentCardId = localStorage.getItem('uc');
          this.cardsSubscription = this.dataTransferService.userCards$.subscribe((res) => {
            this.currentCard = res.find(card => card.id === currentCardId);
          })

          this.voucherData.paymentNeeded = true;
          this.redeemResponseEvent.emit({
            response: 'payment-needed'
          })
        }
        else{
          this.redeemResponseEvent.emit({
            response: 'failed'
          })
          this.voucherData.success = false;
        }
      }
    );
  }
  toString(num){
    return num + '.0';
  }
  getpayments(){
    this.paymentLoad = true;
    const formData: FormData = new FormData();
    formData.append("transactions_attributes[][txn_type]", 'payment_gateway');
    formData.append("transactions_attributes[][amount]", this.toString(this.selectedOffer.pva));
    formData.append("base_url", this.document.location.href);
    formData.append("vcp", 'vp');
    try {
      this.pgService.makePayment(formData);
    } catch (error) {
      if(error && (typeof(error) == 'string')) {
        this.toastr.error(error);
      }
      this.paymentClicked = false;
    }
    // this._apiService.getPaymentLink(formData).subscribe(
    //   (res: any) => {
    //     this.paymentLoad = false;
    //     if(res.status && res.status == 'error'){
    //       this.voucherData.paymentNeeded = false;
    //       this.voucherData.success = false;
    //     }
    //     else{
    //       let payment = res;
    //       payment.payu_body.amount = this.isInteger(payment.payu_body.amount) ? payment.payu_body.amount + ".0" : payment.payu_body.amount;
    //       var form = document.createElement("form");
    //       form.setAttribute("method", "post");
    //       form.setAttribute("action", payment.payu_url);
    //       Object.keys(payment.payu_body).forEach((key) => {
    //         if(payment.payu_body[key]){

    //           var hiddenField = document.createElement("input");
    //           hiddenField.setAttribute("type", "hidden");
    //           hiddenField.setAttribute("name", key);
    //           hiddenField.setAttribute("value", payment.payu_body[key]);
    //           form.appendChild(hiddenField);
    //         }


    //       });
    //       document.body.appendChild(form);
    //       setTimeout(()=>{ form.submit(); }, 300);
    //     }

    //   },
    //   (err) => {

    //   }
    // );
  }
  isInteger(x) {
    return typeof x === "number" && isFinite(x) && Math.floor(x) === x;
  }

  goTo() {
    this.fpService.redeemClicked();
    this.redeeming = true;
    let gotourl = this.voucherData.offer_type && this.voucherData.offer_type === 'link_voucher' ? this.voucherData.voucher_code : this.selectedOffer.redemptionUrl;
    setTimeout(() => {
      window.open(gotourl, '_blank','noopener');
      this.redeeming = false;
      this.redeemActive = false;
    }, 0)
  }

  showCopied(code) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = code;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.success('Copied!');
  }

  ngOnDestroy(): void {
      this.cardsSubscription.unsubscribe()
  }

}
